import type StoreDto from "~/models/StoreDto";
import { type AnybillResult, AnybillResultHelper } from "~/additionalModels/AnybillResponse";
import EndpointPaths from "~/config/constants/EndpointPaths";
import BaseService from "~/services/BaseService";

/**
 * Provider for all display ad (formerly known as Content Areas) things
 */
export class StoreProvider {
  private static _instance: StoreProvider;

  static get instance(): StoreProvider {
    if (StoreProvider._instance === undefined)
      StoreProvider._instance = new StoreProvider();

    return StoreProvider._instance;
  }

  /**
   * Get stores of the vendor customer
   *
   * Default take is 100
   * @returns A list of display ads
   */
  public async getStores(_params?: {
    skip: number;
    take: number;
  }): Promise<AnybillResult<StoreDto[]>> {
    return BaseService.Instance.get<StoreDto[]>(
      { path: EndpointPaths.STORE_PATH, query: _params },
    );
  }

  /**
   * Upload a store icon directly via store controller
   */
  public async uploadStoreIcon(storeId: string, file: File): Promise<AnybillResult<undefined>> {
    const formData = new FormData();
    formData.append("file", file ?? "");

    return BaseService.Instance.post<undefined>(
      {
        path: `${EndpointPaths.STORE_PATH}/${storeId}${EndpointPaths.STORE_ICON_APPEND_PATH}`,
        body: formData,
      },
    );
  }

  /**
   * Delete a store icon directly via store controller
   */
  public async deleteStoreIcon(storeId: string): Promise<AnybillResult<undefined>> {
    return BaseService.Instance.delete<undefined>(
      {
        path: `${EndpointPaths.STORE_PATH}/${storeId}${EndpointPaths.STORE_ICON_APPEND_PATH}`,
      },
    );
  }
}
